import { ColGroupDef } from 'ag-grid-community'
import { intl } from '../../../../../../i18n'
import { ProgramManagementRow } from '../../../programManagement'
import { getAggregatedValue } from './aggregation'
import {
  RowValueGetter,
  RIGHT_ALIGN_STYLE,
  progressValueFormatter,
  percentValueFormatter,
} from './common'

// --- Progress group ---

export const progressColumns: ColGroupDef<ProgramManagementRow> = {
  headerName: intl.formatMessage({ id: 'programManagement.column.progress' }),
  children: [
    {
      colId: 'progress.total',
      headerName: intl.formatMessage({
        id: 'programManagement.column.progress.total',
      }),
      width: 70,
      editable: false,
      cellStyle: RIGHT_ALIGN_STYLE,
      valueGetter: (params: RowValueGetter) =>
        getAggregatedValue(params, 'progress', 'total'),
      valueFormatter: progressValueFormatter,
    },
    {
      colId: 'progress.scheduledCompleted',
      headerName: intl.formatMessage({
        id: 'programManagement.column.progress.scheduledCompleted',
      }),
      width: 80,
      editable: false,
      cellStyle: RIGHT_ALIGN_STYLE,
      valueGetter: (params: RowValueGetter) =>
        getAggregatedValue(params, 'progress', 'scheduledCompleted'),
      valueFormatter: progressValueFormatter,
    },
    {
      colId: 'progress.completed',
      headerName: intl.formatMessage({
        id: 'programManagement.column.progress.completed',
      }),
      width: 70,
      editable: false,
      cellStyle: RIGHT_ALIGN_STYLE,
      valueGetter: (params: RowValueGetter) =>
        getAggregatedValue(params, 'progress', 'completed'),
      valueFormatter: progressValueFormatter,
    },
    {
      colId: 'progress.remaining',
      headerName: intl.formatMessage({
        id: 'programManagement.column.progress.remaining',
      }),
      width: 70,
      editable: false,
      cellStyle: RIGHT_ALIGN_STYLE,
      valueGetter: (params: RowValueGetter) => {
        const total = getAggregatedValue(params, 'progress', 'total')
        const completed = getAggregatedValue(params, 'progress', 'completed')
        if (total == null || completed == null) return null
        return total - completed
      },
      valueFormatter: progressValueFormatter,
    },
    {
      colId: 'progress.delayed',
      headerName: intl.formatMessage({
        id: 'programManagement.column.progress.delayed',
      }),
      width: 70,
      editable: false,
      cellStyle: RIGHT_ALIGN_STYLE,
      valueGetter: (params: RowValueGetter) =>
        getAggregatedValue(params, 'progress', 'delayed'),
      valueFormatter: progressValueFormatter,
    },
    {
      colId: 'progress.preceding',
      headerName: intl.formatMessage({
        id: 'programManagement.column.progress.preceding',
      }),
      width: 70,
      editable: false,
      cellStyle: RIGHT_ALIGN_STYLE,
      valueGetter: (params: RowValueGetter) =>
        getAggregatedValue(params, 'progress', 'preceding'),
      valueFormatter: progressValueFormatter,
    },
    {
      colId: 'progress.scheduledProgressRate',
      headerName: intl.formatMessage({
        id: 'programManagement.column.progress.scheduledProgressRate',
      }),
      width: 90,
      editable: false,
      cellStyle: RIGHT_ALIGN_STYLE,
      valueGetter: (params: RowValueGetter) => {
        const total = getAggregatedValue(params, 'progress', 'total')
        const scheduledCompleted = getAggregatedValue(
          params,
          'progress',
          'scheduledCompleted'
        )
        if (!total || total === 0 || scheduledCompleted == null) return null
        return scheduledCompleted / total
      },
      valueFormatter: percentValueFormatter,
    },
    {
      colId: 'progress.progressRate',
      headerName: intl.formatMessage({
        id: 'programManagement.column.progress.progressRate',
      }),
      width: 80,
      editable: false,
      cellStyle: RIGHT_ALIGN_STYLE,
      valueGetter: (params: RowValueGetter) => {
        const total = getAggregatedValue(params, 'progress', 'total')
        const completed = getAggregatedValue(params, 'progress', 'completed')
        if (!total || total === 0 || completed == null) return null
        return completed / total
      },
      valueFormatter: percentValueFormatter,
    },
  ],
}
